import { Component, ViewChildren, QueryList, ElementRef, Renderer2, AfterViewInit, ChangeDetectorRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { ActionCoCalculatorModel, ActionCoCalculatorMission, ActionCoMissionGroup, ActionCoMissionQuestion, ActionCoMissionPDCGrouped, ActionCoMissionProperty, QueovalItem, ActionCoMissionPDC } from '../../../models';
import { HttpService, CoreService } from '../../../services';
import { ToastService } from '../../../toast';
import { MissionCalculatorService } from '../mission-calculator.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

export interface HTMLQuestionElement extends HTMLDivElement {
  displayed: boolean;
}
export interface HTMLGroupElement extends HTMLDivElement {
  displayed: boolean;
}


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-calculateur-config',
  templateUrl: './calculator-config.component.html',
  styleUrls: ['./calculator-config.component.css', '../mission-calculator.component.css']
})

export class CalculatorConfigComponent implements AfterViewInit {

  public deletingElement: boolean = false;

  public deleteMode: string = '';
  public groupToDelete: ActionCoMissionGroup;
  public indexGroupToDelete: number;

  public questionToDelete: ActionCoMissionQuestion;
  public indexQuestionToDelete: number;

  public labelElementToDelete: string = '';

  public modalDelete: NgbModalRef;

  
  @ViewChildren('QuestionContainer') lstQuestionContainer: QueryList<ElementRef<HTMLQuestionElement>>;
  @ViewChildren('GroupContainer') lstGroupContainer: QueryList<ElementRef<HTMLQuestionElement>>;

  @ViewChild('ModalConfirmDelete', { static: false }) ModalConfirmDelete: ElementRef;

  @Output('openModalCondition') openModalConditionEmitter: EventEmitter<{ Event: any, Pdc: ActionCoMissionPDCGrouped }> = new EventEmitter<{ Event: any, Pdc: ActionCoMissionPDCGrouped }>();
  constructor(
    protected http: HttpService,
    public indParam: CoreService,
    public sanitizer: DomSanitizer,
    public toast: ToastService,
    private renderer: Renderer2,
    protected modalService: NgbModal,
    private cd: ChangeDetectorRef,
    public calculatorService: MissionCalculatorService
  ) { }

  //#region CYCLE DE VIE
  public ngAfterViewInit(): void {
    // récupère le premier parent scrollable de q-action-co-calculateur et lui ajout un listenner
    let parent: string = 'q-action-co-calculateur';
    let scrollParent: any = null;
    if ($(parent).length == 0) {
      parent = 'q-mission-calculateur';
    }

    scrollParent = ($(parent) as any).scrollParent();
    if (scrollParent) {
      scrollParent = scrollParent.length > 0 ? scrollParent[0] : scrollParent;
      this.renderer.listen(scrollParent, 'scroll', (e: any) => {
        //#region au scroll, affiche les groupes et questions 100px avant le bas du viewport
        this.lstGroupContainer.forEach((group: ElementRef<HTMLGroupElement>, index: number) => {
          if (!group.nativeElement.displayed) {
            group.nativeElement.displayed = group.nativeElement.getBoundingClientRect().top < e.currentTarget.offsetHeight + 100;
          }
        });
        this.lstQuestionContainer.forEach((question: ElementRef<HTMLQuestionElement>, index: number) => {
          if (!question.nativeElement.displayed) {
            question.nativeElement.displayed = question.nativeElement.getBoundingClientRect().top < e.currentTarget.offsetHeight + 100;
          }
        });
        this.cd.detectChanges();
        //#endregion
      });
    }
  }
  //#endregion

  //#region METHODES PUBLIQUES

  //#region gestion des groupes
  // par numéro d'ordre
  public sortGroup(group: ActionCoMissionGroup, index: number): void {
    this.calculatorService.Mission.Groups.splice(index, 1);
    this.calculatorService.Mission.Groups.splice(group.Order - 1, 0, group);
    this.OnSaveGroup(group);
    this.calculatorService.Mission.Groups.forEach((g: ActionCoMissionGroup, i: number) => {
      g.Order = i + 1;
      this.OnSaveGroup(g);
    })
  }

  public AddGroup(mission: ActionCoCalculatorMission) {
    this.calculatorService.AddGroup(mission);
  }

  //au blur sur les champs label ou rodre du groupe, OU lorsque l'on réordonne tout les groupes
  public OnSaveGroup(group: ActionCoMissionGroup, indexProp: number = 0, activeTab: string | null = null): void {

    if (group.Ident || (!!group.Label && !!group.Order && group.Questions.length > 0 && !!group.Questions[0].Order && ((group.Questions[0].Obligations && group.Questions[0].Obligations.length > 0) || (group.Questions[0].Properties && group.Questions[0].Properties.length > 0)))) {
      let emptyValue: boolean = false;

      //#region contrôle du label du groupe
      if (!group.Label) { (group as any).LabelEmpty = true; emptyValue = true; }
      else (group as any).LabelEmpty = false;
      //#endregion

      //#region contrôle de l'ordre du groupe
      if (!group.Order) { (group as any).OrderEmpty = true; emptyValue = true; }
      else (group as any).OrderEmpty = false;
      if (emptyValue) {
        this.toast.showWarningToast('Veuillez renseigner les champs manquants.')
        return;
      }
      //#endregion

      const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
      model.Mode = 'SAVE_GROUPS';
      model.Groups.push(group);
      model.Mission.BoName = this.calculatorService.Mission.BoName;
      //model.Ident = this.calculatorService.client.Id;
      this.calculatorService.dataLoading = true;
      this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
        (result: ActionCoCalculatorModel) => {
          if (result.HasSomeError)
            return;
          this.calculatorService.dataLoading = false;
          const isNewGroup = !group.Ident || group.Ident === "0";
          group.Ident = result.Ident;
          if (isNewGroup) {
            //on sauvegarde en cascade la 1ère question si c'est un nouveau groupe
            // car le groupe n'est pas sauvegardé tant qu'il n'y a pas de question valide dedans
            // lorsque l'on sauvegarde un groupe pour la première fois il y a donc forcément une question à sauvegarder avec.
            this.OnSaveQuestion(group.Questions[0], group, indexProp, activeTab);
          }
        });
    } else {
      (group as any).locked = false;
    }
  }

  private OnDeleteGroup(group: ActionCoMissionGroup, index: number): void {
    if (this.modalDelete != null) {
      this.modalDelete.close()
    }
    //suppression de toutes les questions liées au groupe
    group.Questions.forEach(question => {
      this.OnUnlinkAllElements(question);
    });

    this.calculatorService.Mission.Groups.splice(index, 1);

    if (group.Ident && group.Ident != '0') {
      const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
      model.Mode = 'DELETE_GROUPS';
      model.Groups.push(group);
      model.Ident = this.calculatorService.Mission.Ident;
      model.Mission.BoName = this.calculatorService.Mission.BoName;
      this.calculatorService.dataLoading = true;
      this.deletingElement = true;
      this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
        (result: ActionCoCalculatorModel) => {
          this.deletingElement = false;
          // réordonne les groupes avec l'élément en moins et lance la sauvegarde de tout les BOs
          this.calculatorService.Mission.Groups.forEach((g: ActionCoMissionGroup, i: number) => {
            g.Order = i + 1;
            this.OnSaveGroup(g);
          })
          this.calculatorService.dataLoading = false;
        });
    }
  }
  //#endregion
  //#region gestion des questions
  //par numéro d'ordre
  public sortQuestion(question: ActionCoMissionQuestion, group: ActionCoMissionGroup, index: number, questions: Array<ActionCoMissionQuestion>): void {
    questions.splice(index, 1);
    questions.splice(question.Order - 1, 0, question);
    this.OnSaveQuestion(question, group);
    questions.forEach((q: ActionCoMissionQuestion, i: number) => {
      q.Order = i + 1;
      this.OnSaveQuestion(q, group);
    })
  }

  public AddQuestion(event: any, group: ActionCoMissionGroup): void {
    const question = new ActionCoMissionQuestion();
    //#region pousse la nouvelle question à la fin du groupe
    question.Order = group.Questions.length + 1;
    if (group && group.Questions)
      group.Questions.push(question);
    else if (group)
      group.Questions = [question];
    //#endregion
    let scrollParent: JQuery = ($('q-action-co-calculateur') as any).scrollParent();
    if (scrollParent) {
      scrollParent[0].style.scrollBehavior = 'smooth';
      setTimeout(() => {
        scrollParent[0].scrollTo(scrollParent[0].scrollHeight, event.target.offsetTop - window.innerHeight + 70);
      }, 10);
    }
  }

  public OnSaveQuestion(question: ActionCoMissionQuestion, group: ActionCoMissionGroup, indexProp: number = 0, activeTab: string | null = null): void {
    if (!group.Ident) {
      this.OnSaveGroup(group, indexProp, activeTab);
    } else {
      if (question.Ident || (!!question.Order && ((question.Obligations && question.Obligations.length > 0) || (question.Properties && question.Properties.length > 0)))) {
        let emptyValue: boolean = false;

        //#region contrôle de l'ordre du groupe
        if (!question.Order) { (question as any).OrderEmpty = true; emptyValue = true; }
        else (question as any).OrderEmpty = false;
        if (emptyValue) {
          this.toast.showWarningToast('Veuillez renseigner les champs manquants.')
          return;
        }
        //#endregion
        const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
        model.Mode = 'SAVE_QUESTIONS';
        model.Questions.push(question);
        model.Ident = group.Ident;
        this.calculatorService.dataLoading = true;
        this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
          (result: ActionCoCalculatorModel) => {
            if (result.HasSomeError)
              return;
            this.calculatorService.dataLoading = false;
            const isNewQuestion = !question.Ident || question.Ident === "0";
            question.Ident = result.Ident;
            if (isNewQuestion) {
              if (question.Obligations.length > 0) {
                this.OnLinkObligation(question.Obligations[0], question, group, indexProp, false)
              } else if (question.Properties.length > 0 && activeTab != null) {
                this.OnLinkProperty(question, group, activeTab, indexProp, false)
              }
            }
          });
      } else {
        (group as any).locked = false;
      }
    }
  }

  private OnDeleteQuestion(question: ActionCoMissionQuestion, group: ActionCoMissionGroup, iGroup: number, iQuestion: number): void {
    if (this.modalDelete != null) {
      this.modalDelete.close()
    }
    this.OnUnlinkAllElements(question);
    this.calculatorService.Mission.Groups[iGroup].Questions.splice(iQuestion, 1);
    if (question.Ident && question.Ident != '0') {
      const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
      model.Mode = 'DELETE_QUESTIONS';
      model.Questions.push(question);
      model.Ident = group.Ident;
      this.calculatorService.dataLoading = true;
      this.deletingElement = true;
      this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
        (result: ActionCoCalculatorModel) => {
          this.deletingElement = false;
          this.calculatorService.dataLoading = false;
          group.Questions.forEach((q: ActionCoMissionQuestion, i: number) => {
            q.Order = i + 1;
            this.OnSaveQuestion(q, group);
          })
        });
    }
  }
  //#endregion
  //#region gestion des obligations/propriétés
  public sortProp(question: ActionCoMissionQuestion, prop: ActionCoMissionProperty | null = null, index: number = -1): void {
    if (prop && (index || index === 0) && index > -1) {
      question.Properties.splice(index, 1);
      question.Properties.splice(prop.Order - 1, 0, prop);
      this.SaveProperty(question, prop);
    }
    question.Properties.forEach((p: ActionCoMissionProperty, i: number) => {
      p.Order = i + 1;
      this.SaveProperty(question, p);
    })
  }

  public sortObligation(group: ActionCoMissionGroup, question: ActionCoMissionQuestion, obligation: ActionCoMissionPDCGrouped | null = null, index: number = -1): void {
    if (obligation && (index || index === 0) && index > -1) {
      question.Obligations.splice(index, 1);
      question.Obligations.splice(obligation.Order - 1, 0, obligation);
      this.SaveObligation(group, question, obligation);
    }
    question.Obligations.forEach((o: ActionCoMissionPDCGrouped, i: number) => {
      o.Order = i + 1;
      this.SaveObligation(group, question, o);
    })
  }

  public OnLinkObligation(obligation: ActionCoMissionPDCGrouped, question: ActionCoMissionQuestion, group: ActionCoMissionGroup, index: number, pushObligation: boolean = true): void {
    if (pushObligation) {
      (question as any).PropsEmpty = false;
      if (question.Obligations) {
        question.Obligations.push(obligation);
      } else {
        question.Obligations = [obligation];
      }
      obligation.Order = question.Obligations.length;
      question.Obligations.sort((a, b) => a.Order - b.Order);
      this.calculatorService.Mission.ObligationsProperties.splice(index, 1);
    }
    this.calculatorService.Mission.ObligationsProperties = [...this.calculatorService.Mission.ObligationsProperties];
    this.cd.detectChanges();
    if (!question.Ident) {
      (group as any).locked = true;
      this.OnSaveQuestion(question, group, index)
    } else {
      this.SaveObligation(group, question, obligation);
    }
  }

  public SaveObligation(group: ActionCoMissionGroup, question: ActionCoMissionQuestion, obligation: ActionCoMissionPDCGrouped) {
    const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
    model.Mode = 'LINK_OBLIGATIONS';
    model.Obligations.push(obligation);
    model.Ident = question.Ident;
    this.calculatorService.dataLoading = true;
    this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
      (result: ActionCoCalculatorModel) => {
        this.calculatorService.dataLoading = false;
        (group as any).locked = false;
        if (!result.HasError) {

        }
      });
  }

  public OnUnlinkObligation(obligation: ActionCoMissionPDCGrouped, question: ActionCoMissionQuestion, index: number): void {
    question.Obligations.splice(index, 1);
    this.calculatorService.Mission.ObligationsProperties.push(obligation);
    this.calculatorService.Mission.ObligationsProperties.sort((a: ActionCoMissionPDCGrouped, b: ActionCoMissionPDCGrouped) => {
      if (!a.Code && a.Code !== '') return -1;
      if (!b.Code && b.Code !== '') return 1;
      return a.Code.localeCompare(b.Code);
    });
    this.calculatorService.Mission.ObligationsProperties = [...this.calculatorService.Mission.ObligationsProperties];
    this.cd.detectChanges();
    const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
    model.Mode = 'UNLINK_OBLIGATIONS';
    model.Obligations.push(obligation);
    model.Ident = question.Ident;
    this.calculatorService.dataLoading = true;
    this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
      (result: ActionCoCalculatorModel) => {
        this.calculatorService.dataLoading = false;
        if (!result.HasError) {
          this.sortObligation(new ActionCoMissionGroup(), question);
        }
      });
  }

  public OnLinkProperty(question: ActionCoMissionQuestion, group: ActionCoMissionGroup, activeTab: string, index: number, pushProperty: boolean = true): void {

    let propertyData: ActionCoMissionProperty = activeTab === 'MISSION' ? this.calculatorService.Mission.MissionsProperties[index] : this.calculatorService.Mission.ClientsProperties[index];
    let origin: Array<ActionCoMissionProperty> = activeTab === 'MISSION' ? this.calculatorService.Mission.MissionsProperties : this.calculatorService.Mission.ClientsProperties;
    (propertyData as any).origin = question.ActiveTab;
    if (pushProperty) {
      (question as any).PropsEmpty = false;
      if (question.Properties) {
        question.Properties.push(propertyData);
      } else {
        question.Properties = [propertyData];
      }
      propertyData.Order = question.Properties.length;
      question.Properties.sort((a, b) => a.Order - b.Order);
      origin.splice(index, 1);
      if (activeTab === 'MISSION') {
        this.calculatorService.Mission.MissionsProperties = [...origin];
      }
      else {
        this.calculatorService.Mission.ClientsProperties = [...origin];
      }

      this.cd.detectChanges();
      this.calculatorService.AffectRequiredMissionProperties(this.calculatorService.Mission);
    }

    if (!question.Ident) {
      this.OnSaveQuestion(question, group, index, activeTab)
    } else {
      this.SaveProperty(question, propertyData);
    }
  }

  public SaveProperty(question: ActionCoMissionQuestion, propertyData: ActionCoMissionProperty) {
    const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
    model.Mode = 'LINK_PROPERTIES';
    model.Properties.push(propertyData);
    model.Ident = question.Ident;
    this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
      (result: ActionCoCalculatorModel) => {
        if (!result.HasError) {

        }
      });
  }

  public OnUnlinkProperty(propertyData: ActionCoMissionProperty, question: ActionCoMissionQuestion, index: number): void {
    let origin: Array<ActionCoMissionProperty> = this.calculatorService.Mission.MissionsProperties.length > 0 && this.calculatorService.Mission.MissionsProperties[0].Value.CodeIdentUnique.slice(-3) === propertyData.Value.CodeIdentUnique.slice(-3) ? this.calculatorService.Mission.MissionsProperties :
      this.calculatorService.Mission.ClientsProperties.length > 0 && this.calculatorService.Mission.ClientsProperties[0].Value.CodeIdentUnique.slice(-3) === propertyData.Value.CodeIdentUnique.slice(-3) ? this.calculatorService.Mission.ClientsProperties :
        this.calculatorService.Mission.MissionsProperties;

    question.Properties.splice(index, 1);
    if (origin) {
      origin.push(propertyData);
    } else {
      origin = [propertyData];
    }

    origin.sort((a: ActionCoMissionProperty, b: ActionCoMissionProperty) => {
      if (!a.Value.MainLabel.Value && a.Value.MainLabel.Value !== '') return -1;
      if (!b.Value.MainLabel.Value && b.Value.MainLabel.Value !== '') return 1;
      return a.Value.MainLabel.Value.localeCompare(b.Value.MainLabel.Value);
    });
    if (this.calculatorService.Mission.MissionsProperties.length > 0 && this.calculatorService.Mission.MissionsProperties[0].Value.CodeIdentUnique.slice(-3) === propertyData.Value.CodeIdentUnique.slice(-3)) {
      this.calculatorService.Mission.MissionsProperties = [...origin];
    } else if (this.calculatorService.Mission.ClientsProperties.length > 0 && this.calculatorService.Mission.ClientsProperties[0].Value.CodeIdentUnique.slice(-3) === propertyData.Value.CodeIdentUnique.slice(-3)) {
      this.calculatorService.Mission.ClientsProperties = [...origin];
    } else {
      this.calculatorService.Mission.MissionsProperties = [...origin];
    }
    this.cd.detectChanges();
    this.calculatorService.AffectRequiredMissionProperties(this.calculatorService.Mission);

    const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
    model.Mode = 'UNLINK_PROPERTIES';
    model.Properties.push(propertyData);
    model.Ident = question.Ident;
    this.calculatorService.dataLoading = true;
    this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
      (result: ActionCoCalculatorModel) => {
        this.calculatorService.dataLoading = false;
        if (!result.HasError) {
          this.sortProp(question);
        }
      });
  }

  public GetPropOrigin(prop: ActionCoMissionProperty): string {
    return this.calculatorService.Mission.MissionsProperties.length > 0 && this.calculatorService.Mission.MissionsProperties[0].Value.CodeIdentUnique.slice(-3) === prop.Value.CodeIdentUnique.slice(-3) ? 'MISSION' :
      this.calculatorService.Mission.ClientsProperties.length > 0 && this.calculatorService.Mission.ClientsProperties[0].Value.CodeIdentUnique.slice(-3) === prop.Value.CodeIdentUnique.slice(-3) ? 'CUSTOMER' :
        'MISSION';
  }

  public OpenModalCondition(e: any, selectedPdc: ActionCoMissionPDCGrouped) {
    this.openModalConditionEmitter.emit({ Event: e, Pdc: selectedPdc });
  }

  public OpenModalDelete(mode: string, group: ActionCoMissionGroup, iGroup: number, question: ActionCoMissionQuestion = new ActionCoMissionQuestion(), iQuestion: number = -1): void {
    this.groupToDelete = group;
    this.indexGroupToDelete = iGroup;

    this.questionToDelete = question;
    this.indexQuestionToDelete = iQuestion;
    this.labelElementToDelete = iQuestion > -1 ? question.Label : group.Label;

    this.deleteMode = mode;
    this.modalDelete = this.modalService.open(this.ModalConfirmDelete, { size: 'q-long', centered: true, windowClass: 'qmodalover' });
  }

  public DeleteGroupOrQuestion(): void {
    switch (this.deleteMode.toLocaleLowerCase()) {
      case 'group':
        this.OnDeleteGroup(this.groupToDelete, this.indexGroupToDelete);
        break;
      case 'question':
        this.OnDeleteQuestion(this.questionToDelete, this.groupToDelete, this.indexGroupToDelete, this.indexQuestionToDelete);
        break;
    }
  }


  public DisableTrashGroup(group: ActionCoMissionGroup): boolean {
    for (let i: number = 0; i < group.Questions.length; i++) {
      if (group.Questions[i].Obligations.length > 0 || group.Questions[i].Properties.length > 0)
        return true;
    }
    return false;
  }

  public DisableTrashQuestion(question: ActionCoMissionQuestion): boolean {
    if (question.Obligations.length > 0 || question.Properties.length > 0)
        return true;
    
    return false;
  }
  //#endregion
  //#endregion

  private OnUnlinkAllElements(question: ActionCoMissionQuestion): void {
    question.Obligations.forEach(obligation => {
      this.calculatorService.Mission.ObligationsProperties.push(obligation);
    });
    this.calculatorService.Mission.ObligationsProperties.sort((a: ActionCoMissionPDCGrouped, b: ActionCoMissionPDCGrouped) => {
      if (!a.Code && a.Code !== '') return -1;
      if (!b.Code && b.Code !== '') return 1;
      return a.Code.localeCompare(b.Code);
    });
    question.Properties.forEach(prop => {
      const origin: Array<ActionCoMissionProperty> = this.calculatorService.Mission.MissionsProperties.length > 0 && this.calculatorService.Mission.MissionsProperties[0].Value.CodeIdentUnique.slice(-3) === prop.Value.CodeIdentUnique.slice(-3) ? this.calculatorService.Mission.MissionsProperties :
        this.calculatorService.Mission.ClientsProperties.length > 0 && this.calculatorService.Mission.ClientsProperties[0].Value.CodeIdentUnique.slice(-3) === prop.Value.CodeIdentUnique.slice(-3) ? this.calculatorService.Mission.ClientsProperties :
          this.calculatorService.Mission.MissionsProperties;
      origin.push(prop);
    });
    this.calculatorService.Mission.MissionsProperties.sort((a: ActionCoMissionProperty, b: ActionCoMissionProperty) => {
      if (!a.Value.MainLabel.Value && a.Value.MainLabel.Value !== '') return -1;
      if (!b.Value.MainLabel.Value && b.Value.MainLabel.Value !== '') return 1;
      return a.Value.MainLabel.Value.localeCompare(b.Value.MainLabel.Value);
    });
    this.calculatorService.Mission.ClientsProperties.sort((a: ActionCoMissionProperty, b: ActionCoMissionProperty) => {
      if (!a.Value.MainLabel.Value && a.Value.MainLabel.Value !== '') return -1;
      if (!b.Value.MainLabel.Value && b.Value.MainLabel.Value !== '') return 1;
      return a.Value.MainLabel.Value.localeCompare(b.Value.MainLabel.Value);
    });
  }
}

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'FilterObligation' })
export class FilterObligation implements PipeTransform {
  constructor(public cd: ChangeDetectorRef) { }
  transform(obligations: Array<ActionCoMissionPDCGrouped>, filter: string): any[] {
    this.cd.detectChanges();

    let filteredObligation: Array<{ index: number, value: ActionCoMissionPDCGrouped }> = new Array<{ index: number, value: ActionCoMissionPDCGrouped }>();
    let index: number = 0;
    if (obligations)
      obligations.forEach((value: ActionCoMissionPDCGrouped) => {
        if (!filter || (value.Code && value.Code.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) || (value.Values && value.Values.findIndex(v => v.Info.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) > 0)) {
          filteredObligation = [...filteredObligation, { index, value }];
        }
        index++;
      });


    this.cd.detectChanges();

    return filteredObligation;
  }
}

@Pipe({ name: 'FilterProperty' })
export class FilterProperty implements PipeTransform {
  constructor(public cd: ChangeDetectorRef) { }
  transform(properties: Array<ActionCoMissionProperty>, filter: string): any[] {
    this.cd.detectChanges();

    let filteredProperties: Array<{ index: number, value: ActionCoMissionProperty }> = new Array<{ index: number, value: ActionCoMissionProperty }>();
    let index: number = 0;
    if (properties)
      properties.forEach((value: ActionCoMissionProperty) => {
        if (!filter || (value && value.Value.MainLabel && value.Value.MainLabel.Value && value.Value.MainLabel.Value.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) || (value.Value.CodeIdentUnique && value.Value.CodeIdentUnique.toLocaleLowerCase().includes(filter.toLocaleLowerCase()))) {
          filteredProperties = [...filteredProperties, { index, value }];
        }
        index++;
      });


    this.cd.detectChanges();

    return filteredProperties;
  }
}



